module.exports = __webpack_public_path__ + "static/banner-moc-1-1-34bfeb5a3587a7902d8fbb25ec9c318c.png";